import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@models/location';
import { environment } from '../../environments/environment';

@Injectable()
export class LocationService {

  private BASE_URL = environment.serverUrl + 'locations';

  constructor(private http: HttpClient) { }

  searchLocations(name: string): Observable<Location[]> {
    return this.http.get(this.BASE_URL + '?match=' + encodeURIComponent(name))
      .pipe(map((response) => response as Location[]));
  }
}
